import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";

import { rootSaga } from "../saga/rootSaga";

import { authReducer } from "./auth/auth-slice";
import { bookingReducer } from "./booking/booking-slice";
import { driverReducer } from "./driver/driver-slice";

import { pricingReducer } from "./pricing/slice";

import { routePricingReducer } from "./route-pricing/route-pricing-slice";

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];

const store = configureStore({
  middleware,
  devTools: false,
  reducer: {
    auth: authReducer,
    booking: bookingReducer,
    driver: driverReducer,
    pricing: pricingReducer,
    routePricing: routePricingReducer,
  },
});

sagaMiddleware.run(rootSaga);
export default store;
